document.addEventListener('DOMContentLoaded', function() {

    // SEARCH PANEL TOGGLE
    document.querySelectorAll(".open-search-btn").forEach(function (event) {
        event.addEventListener("click", function (event) {
            if(window.innerWidth > 1199) {
                event.target.classList.toggle('active');
            }
            
            var subNavProg = document.getElementById("sub-nav");
    
            // Toggle shadow for program only
            if(subNavProg != null) {
                document.getElementById('sub-nav').classList.toggle('boxshadow');
            }
            document.querySelector(".filters-container").classList.toggle("open");
            
        });
    });
    
    function displayTextWidth(text, font) {
        var myCanvas =
            displayTextWidth.canvas ||
            (displayTextWidth.canvas = document.createElement("canvas"));
        var context = myCanvas.getContext("2d");
        context.font = font;
    
        var metrics = context.measureText(text);
        return metrics.width;
    }
    
    $(".dropdown.keep-open").on({
        "hide.bs.dropdown": function (e) {
            return typeof e.clickEvent != "object";
        },
    });
    
    document
        .querySelectorAll('.dropdown-item[data-input="region"]')
        .forEach(function (item) {
            var length =
                displayTextWidth(
                    item.textContent,
                    "normal 16px Montserrat-Regular "
                ) + 80;
            item.querySelector(".hr").style.width = "calc(100% - " + length + "px)";
        });
    document
        .querySelectorAll('.dropdown-item[data-input="department"]')
        .forEach(function (item) {
            var length =
                displayTextWidth(
                    item.textContent,
                    "bold 21px Montserrat-SemiBold "
                ) + 15;
            item.querySelector(".l-hr").style.left =
                "calc(15px + " + length + "px)";
        });
    
    // Filter location menu based on user input
    document
        .getElementById("location-input")
        .addEventListener("keyup", function (e) {
            console.log('hh')
            var input, filter, ul, li, a, i;
    
            input = e.target;
            filter = input.value.toLowerCase();
            var count = input.value.length;
    
            var div = document.querySelector("#location-filter .dropdown-menu");
            var btn = div.getElementsByTagName("button");
    
            for (i = 0; i < btn.length; i++) {
                var txtValue = btn[i].textContent || btn[i].innerText;
                if (
                    txtValue.toLowerCase().indexOf(filter) > -1 ||
                    normalizeText(txtValue.toLowerCase()).indexOf(filter) > -1 ||
                    noHypenText(txtValue.toLowerCase()).indexOf(filter) > -1 ||
                    normalizeText(noHypenText(txtValue.toLowerCase())).indexOf(
                        filter
                    ) > -1
                ) {
                    btn[i].style.display = "";
                    var splits = highlight(txtValue, count);
                    btn[i].innerHTML =
                        '<span class="highlight">' +
                        splits[0] +
                        "</span>" +
                        splits[1];
                } else {
                    btn[i].style.display = "none";
                }
            }
        });
    
    function highlight(txtValue, count) {
        var splits = [
            txtValue.substring(0, count),
            txtValue.substring(count, txtValue.length),
        ];
        return splits;
        //return text.replace(new RegExp(filter, 'gi'), '<span class="highlighted">$&</span>');
    }
    
    function normalizeText(txt) {
        txt = txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return txt;
    }
    
    function noHypenText(txt) {
        txt = txt.replace(/-/g, " ");
        return txt;
    }
    
    // Set field value based on user choice
    /*function selectValue(input, e) {
            if(input == 'location') {
                document.querySelector('#level-input').value = e.dataset.level;
            }
            else {
                document.getElementById(input +"-input").value = e.textContent;
                document.getElementById(input +"-menu").textContent = e.textContent;
            }
        }*/
    
    var Values = {
        type: document.querySelector("#type-input").value.split(","),
        rooms: document.querySelector("#rooms-input").value.split(","),
        region: document.querySelector("#region-input").value.split(","),
        department: document.querySelector("#department-input").value.split(","),
        city: document.querySelector("#city-input").value.split(","),
    };
    
    // DECLARE HANDLER
    function clickHandler(e) {
        var selectedType = e.target.dataset.input;
    
        if (
            e.target.parentElement.classList.contains("dropdown-menu") ||
            e.target.parentElement.classList.contains("level")
        ) {
            e.target.classList.toggle("checked");
        } else {
            if (
                selectedType == "region" ||
                selectedType == "department" ||
                selectedType == "city"
            ) {
                var items = document.querySelectorAll(
                    "#location-filter .dropdown-item"
                );
            } else {
                var items = document.querySelectorAll(
                    "#" + selectedType + "-filter .dropdown-item"
                );
            }
    
            items.forEach(function (item) {
                console.log(item.textContent, e.target.textContent);
                if (item.textContent == e.target.textContent) {
                    item.classList.toggle("checked");
                }
            });
        }
    
        // Remove trailing comma
        if (Values[selectedType][0] == "") {
            Values[selectedType].splice(Values[selectedType][0], 1);
        }
    
        // Add or remove values
        if (Values[selectedType].includes(e.target.textContent) == false) {
            Values[selectedType].push(e.target.textContent);
        } else {
            Values[selectedType].splice(
                Values[selectedType].indexOf(e.target.textContent),
                1
            );
        }
        document.querySelector("#" + selectedType + "-input").value = Values[
            selectedType
        ].join(",");
    
        // Update html / txt field
        if (
            selectedType == "region" ||
            selectedType == "department" ||
            selectedType == "city"
        ) {
            var txt = Values["region"].concat(Values["department"], Values["city"]);
    
            // txt = txt.filter(item => item);
    
            txt = txt.filter(function (item) {
                return item;
            });
    
            if (txt.length > 20) {
                txt = txt.substring(0, 20) + "...";
            }
            if (txt.length > 0 && window.innerWidth > 1199)
                document.querySelector("#location-menu").innerHTML =
                    '<span class="text-primary text-left text-xl-center d-block mts-m">' +
                    txt +
                    "</span>";
            else {
                document.querySelector(
                    "#location-menu"
                ).textContent = document.querySelector(
                    "#location-menu"
                ).dataset.placeholder;
            }
            document.querySelector("#location-input").value = "";
    
            document
                .querySelectorAll("#location-filter .dropdown-menu .dropdown-item")
                .forEach(function (item) {
                    item.style.display = "block";
                });
        } else {
            var txt = Values[selectedType].join(", ");
    
            if (txt.length > 16) {
                txt = txt.substring(0, 16) + "...";
            }
            if (txt.length > 0 && window.innerWidth > 1199)
                document.querySelector("#" + selectedType + "-menu").innerHTML =
                    '<span class="text-primary text-left text-xl-center d-block mts-m">' +
                    txt +
                    "</span>";
            else {
                document.querySelector(
                    "#" + selectedType + "-menu"
                ).textContent = document.querySelector(
                    "#" + selectedType + "-menu"
                ).dataset.placeholder;
            }
        }
    
        // APPEND OR REMOVE CHILD FOR < 1200px
        if (
            selectedType == "region" ||
            selectedType == "department" ||
            selectedType == "city"
        ) {
            var selectedOverview = document.querySelector(
                "#mobile-location-overview"
            );
            var selectedItems = document.querySelectorAll(
                "#location-filter .dropdown-menu .dropdown-item.checked"
            );
        } else {
            var selectedOverview = document.querySelector(
                "#mobile-" + selectedType + "-overview"
            );
            var selectedItems = document.querySelectorAll(
                "#" + selectedType + "-filter .dropdown-menu .dropdown-item.checked"
            );
        }
    
        selectedOverview.textContent = null;
    
        selectedItems.forEach(function (item) {
            selectedOverview.appendChild(item.cloneNode(true));
        });
    
        /*for(var i = 0; i < Values[selectedType].length; i++) {
                if(Values[selectedType][i] == e.target.textContent) {
                    selectedOverview.appendChild(e.target.cloneNode(true));
                }
                else {
                    selectedOverview.removeChild(e.target);
                }
            }*/
    }
    
    // reference to a list
    const list = document
        .querySelectorAll(".dropdown-menu, .mobile-search-overview")
        .forEach(function (item) {
            // add a single listener on list item
            item.addEventListener("click", clickHandler);
        });
});
